/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpInterceptorFn,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SecureStorageService } from '../services/secure-storage.service';

@Injectable()
export class CustomHeadersInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const correlationId =
      localStorage.getItem('correlationId') || this.generateCorrelationId();
    localStorage.setItem('correlationId', correlationId);

    request = request.clone({
      setHeaders: {
        'x-correlation-id': correlationId,
      },
    });

    return next.handle(request);
  }

  private generateCorrelationId(): string {
    return crypto.randomUUID();
  }
}

export const customHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const secureStorage = inject(SecureStorageService);

  const correlationId =
    secureStorage.getItem('correlationId') || crypto.randomUUID();
  const userName = secureStorage.getItem('loggedInUserName') || '';

  const modifiedReq = req.clone({
    setHeaders: {
      'X-Correlation-ID': correlationId,
      'X-User-Name': userName,
    },
  });

  return next(modifiedReq);
};
